import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";
import { CommentDataProps } from "./useGetConsoleQrSystemDetail";

interface SuppliesDetailRequest {
    category: string;
    list_no: string;
}

export interface SuppliesDetailResponse {
    // statusCode: number;
    // message: string;
    // data: {
    flag: boolean;
    list_no: number;
    bl_no: string;
    subject: string;
    is_app?: boolean; // 앱(모바일) 신청 여부
    contents: string;
    memo?: string; // 관리자 메모
    company: string;
    boss: string; // 대표자
    m_email: string;
    mobile: string;
    result: number;
    w_date: string;
    comment: CommentDataProps[];
    // };
}

export const useGetConsoleTrackingSuppliesDetail = ({
    category,
    list_no,
}: SuppliesDetailRequest): UseQueryResult<SuppliesDetailResponse, Error> => {
    let url = enum_api_uri.get_console_way_bill_detail.replace(":category", category).replace(":list_no", list_no);
    return useQuery({
        queryKey: ["useGetConsoleTrackingSuppliesDetail", category, list_no],
        queryFn: async () => {
            const response = await axiosInstance.get(
                url,
                //     {
                //     params: {
                //         category,
                //         list_no,
                //     },
                // }
            );
            return response.data.data;
        },
        enabled: !!category && !!list_no,
    });
};
